import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PrimaryButton from "../../components/button/PrimaryButton";
import { isEmpty } from "../../helpers/validator";
import { createSuperAdminTenantAdmin } from "../../services/superadmin-tenants";

const TenantAdminCreate = () => {
  const { tenantCode } = useParams();
  const navigate = useNavigate();
  const [admin, setAdmin] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  });
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const updateAdmin = (key, value) =>
    setAdmin((prev) => ({ ...prev, [key]: value }));

  const handleSave = async () => {
    const nextErrors = [];
    if (isEmpty(admin.email)) nextErrors.push("Email is required.");
    if (isEmpty(admin.password)) nextErrors.push("Password is required.");
    if (isEmpty(admin.firstName)) nextErrors.push("First name is required.");
    if (isEmpty(admin.lastName)) nextErrors.push("Last name is required.");
    if (nextErrors.length > 0) {
      setErrors(nextErrors);
      return;
    }

    setSaving(true);
    setErrors([]);
    try {
      await createSuperAdminTenantAdmin(tenantCode, admin);
      navigate(`/su/admin/tenants/${tenantCode}`, { replace: true });
    } catch (e) {
      setErrors([e.message]);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded shadow p-6">
      <h1 className="uppercase text-xl font-bold text-slate-700 mb-6">
        Add Tenant Admin
      </h1>
      {errors.length > 0 ? (
        <div className="bg-errorBg text-errorText text-sm p-4 mb-6 border-errorBorder border-[0.5px] rounded-sm">
          <ul>{errors.map((error, index) => <li key={index}>{error}</li>)}</ul>
        </div>
      ) : null}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input label="Email" type="email" value={admin.email} onChange={(value) => updateAdmin("email", value)} />
        <Input label="Password" type="password" value={admin.password} onChange={(value) => updateAdmin("password", value)} />
        <Input label="First Name" value={admin.firstName} onChange={(value) => updateAdmin("firstName", value)} />
        <Input label="Last Name" value={admin.lastName} onChange={(value) => updateAdmin("lastName", value)} />
      </div>
      <div className="flex justify-end mt-8">
        <PrimaryButton title="Create Admin" onClick={handleSave} isBusy={saving} />
      </div>
    </div>
  );
};

const Input = ({ label, value, onChange, type = "text" }) => (
  <div>
    <label className="block uppercase text-slate-600 text-xs font-bold mb-2">
      {label}
    </label>
    <input
      type={type}
      aria-label={label}
      className="border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-neutral-light rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default TenantAdminCreate;
